export const PARAM_GROUP = {
  FEDERAL_UNIT: 'FEDERAL_UNIT',
  ECONOMIC_ACTIVITY: 'ECONOMIC_ACTIVITY',
};

export const QUOTATION_STATUS = {
  PENDING: 'PE',
  PROPOSAL: 'PR',
  POLICY: 'PO',
};

export const POLICY_VALIDITY_DAYS = 365;
export const PROPOSAL_EXPIRATION_DAYS = 15;

export const CAPTCHA_ERRORS = {
  INVALID_CAPTCHA: {
    MESSAGE: 'Captcha is invalid',
    CODE: 'INVALID-CAPTCHA',
  },
  INVALID_CREDENTIALS: {
    MESSAGE: 'Credentials are invalid',
    CODE: 'CREDENTIAL-INVALID',
  },
};

export const ARTICO_ENDPOINT = {
  QUERY_PERSON: '/person-identity/findByDocument/',
  QUERY_INTERMEDIARY: '/intermediary/findByDocument/',
  QUERY_PROPOSALS_LIST: '/web/property/br/proposals/list',
  QUERY_PROPOSALS_LIST_RESUME: '/web/property/br/proposals/listResume',
  QUERY_PROPOSALS: '/web/property/br/proposals',
  QUERY_UPDATE_PROPOSAL: '/web/property/br/proposal/update/',
  QUERY_REJECT_PROPOSAL: '/web/proposals/reject/',
  QUERY_POLICY_EMIT: '/web/property/br/policy/emit',
  QUERY_CATALOGUE: '/configurations/catalog/',
  QUERY_PROPOSALS_LIST_MP: '/artico-mp/policy/journey',
  QUERY_PROPOSAL_STATES_LIST_MP: '/artico-mp/policy/journey-states',
  QUERY_CATALOGUE_MP: '/artico-mp/catalog/',
  AUTOMATA_POLICY: '/artico-mp/automata/policy-state/',
  POLICY_STATE_HISTORY: '/artico-mp/policy-state-history/',
  POLICY_MP: '/artico-mp/policy/',
  USER: '/artico-mp/user/',
  PRODUCT: '/artico-mp/product/',
  ALERT: '/artico-mp/compliance/alert/',
  REASEGURO: '/artico-mp/reaseguro/',
  PARAMETER_MP: '/artico-mp/parameter/',
  PRIORITY: '/artico-mp/policy-priority/',
  VALIDATE_PRE_EMISION: '/artico-mp/validate-pre-emission/',
};

export const SECTION_CODES = {
  insured: 'asegurado',
  beneficiary: 'beneficiario',
  broker: 'corredor',
  contractor: 'contratante',
  endosatary: 'endosatario',
  promotor: 'promotor',
  datosgenerales: 'datosgenerales',
  coinsuranceAccepted: 'coaseguroaceptado',
  coinsuranceCedido: 'coasegurocedido',
  coinsuranceGeneral: 'coasegurogeneral',
  facultative: 'facultativo',
  specialAccept: 'aceptacionespecial',
  generico: 'coberturas',
  configuracionpago: 'configuracionpago',
  assistence: 'assistence',
};

export const COUNTRIES = {
  BRASIL: 'BR',
  MEXICO: 'MX',
  PERU: 'PE',
  USA: 'US',
};

export const ROLES = [
  'ARTICO-MP-ADMIN',
  'ARTICO-MP-COMERCIAL',
  'ARTICO-MP-SUSCRIPCION',
  'ARTICO-MP-OPERACIONES',
  'ARTICO-MP-CONFIGURADOR',
  'ARTICO-MP-CUMPLIMIENTO',
];

export const ROLESobj = {
  ARTICO_MP_ADMIN: 'ARTICO-MP-ADMIN',
  ARTICO_MP_COMERCIAL: 'ARTICO-MP-COMERCIAL',
  ARTICO_MP_COMERCIAL_PRACTICANTE: 'ARTICO-MP-COMERCIAL-PRACTICANTE',
  ARTICO_MP_SUSCRIPCION: 'ARTICO-MP-SUSCRIPCION',
  ARTICO_MP_OPERACIONES: 'ARTICO-MP-OPERACIONES',
  ARTICO_MP_CONFIGURADOR: 'ARTICO-MP-CONFIGURADOR',
  ARTICO_MP_CUMPLIMIENTO: 'ARTICO-MP-CUMPLIMIENTO',
};
